import React from "react";
import history from "../../utils/history";
import urls from "../../global/constants/UrlConstants";
import YhButton from "../../ui/YhButton";
import { canViewMarketing } from "../../Shared/AppDrawer/menuPrivileges";

/** Blocks Marketing pages when the user lacks Marketing access. */
const MarketingAccessGate = ({ children }: { children: React.ReactNode }) => {
  if (canViewMarketing()) {
    return <>{children}</>;
  }

  return (
    <div className="flex h-[calc(100vh-68px)] items-center justify-center bg-white p-6">
      <div className="max-w-md rounded-2xl border border-[#EEF0F5] bg-white p-8 text-center shadow-sm">
        <h1 className="text-xl font-bold text-[#111827]">Marketing</h1>
        <p className="mt-2 text-sm text-[#6B7280]">
          You do not have permission to access Marketing. Ask an admin to grant
          Marketing on your role in Roles &amp; Privileges.
        </p>
        <YhButton
          className="mt-6"
          onClick={() => history.push(urls.dashboardViewPath)}
        >
          Back to dashboard
        </YhButton>
      </div>
    </div>
  );
};

export default MarketingAccessGate;
